<template>
  <div></div>
</template>
<script>
import {removeCookieInfo, logout} from '@/util';

export default {
  beforeCreate() {
    const {redirect} = this.$route.query;
    removeCookieInfo();
    logout(encodeURIComponent(`${redirect || ''}`));
  },
};
</script>
<style lang="scss" scoped>
</style>
